import { NaniumObject, RequestType } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { News } from "../../entities/news.entity";

export class NewsGetRequestBody extends NaniumObject<NewsGetRequestBody> {
	id?: string;
}

@RequestType({
	responseType: News,
	genericTypes: { TRequestBody: NewsGetRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class NewsGetRequest extends ServiceRequestBase<NewsGetRequestBody, News> {
	static serviceName: string = 'NaniumDemo:news/get';
}
